<div class="media-info">

  <div class="media-info__date">
    <span class="media-info__calendar">
        <mat-icon svgIcon="calendar-grey"></mat-icon>
    </span>
    <span class="media-info__datetime__text">投稿日: {{ dateTime }}</span>
  </div>

  <div class="media-info__brand">
    <img
      src="assets/images/kids-logo.png"
      alt="Logo"
      class="media-info__logo"
    />

    <span class="media-info__kids">Kids</span>
  </div>

</div>